import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Partner} from "../../../../shared/interface/partner";
import {ReceivablesBalance} from "../../../../shared/interface/receivables-balance";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {PartnerService} from "../../../../shared/services/partner.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {validIban} from "../../../../shared/validator/iban-validator";
import {delay, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {ReceivablesBalanceService} from "../../../../shared/services/receivables-balance.service";

export interface ReceivablesBalanceNoteDialogData {
  receivablesBalance: ReceivablesBalance;
}
@Component({
  selector: 'app-receivables-balance-note-add',
  templateUrl: './receivables-balance-note-add.component.html',
  styleUrls: ['./receivables-balance-note-add.component.scss']
})
export class ReceivablesBalanceNoteAddComponent implements OnInit, OnDestroy {

  noteForm: FormGroup;
  receivablesBalanceObject: ReceivablesBalance;
  processingRequest = false;
  noteControl: FormControl;
  enableSaveButton = false;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    public dialogRef: MatDialogRef<ReceivablesBalanceNoteAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReceivablesBalanceNoteDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private receivablesBalanceService: ReceivablesBalanceService,
    private snack: MatSnackBar,
  ) {
    this.receivablesBalanceObject = data.receivablesBalance;
    this.noteForm = fb.group({
      note: this.noteControl = fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.noteForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.noteForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    this.processingRequest = true;

    this.receivablesBalanceService.sendNote(this.noteForm.value, this.receivablesBalanceObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie dodano notatkę', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas dodawania notatki  wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}
